export default {
  'clientInfo.add': 'Añadir banner',
  'clientInfo.selectActivityType': 'Seleccione el tipo de entrada de actividad',
  'clientInfo.activityType': 'Tipo de Entrada de Actividad',
  'clientInfo.firstDepositSuccess': 'Primer Depósito Exitoso',
  'clientInfo.firstDepositSubmit': 'Primer Depósito Enviado',
  'clientInfo.registerNoDeposit': 'Registrado sin Depósito',
  'clientInfo.bannerTitle': 'Título',
  'clientInfo.enterBannerTitle': 'Ingrese título',
  'clientInfo.bannerTitleMaxLength': 'La longitud del título no puede exceder 50 caracteres',
  'clientInfo.displayTarget': 'Grupos de Usuarios Visibles',
  'clientInfo.allUsers': 'Todos los Usuarios',
  'clientInfo.allUsersOneClick': 'Todos los Usuarios',
  'clientInfo.advancedSettings': 'Configuración Avanzada (Opcional)',
  'clientInfo.liveStreamTag': 'Transmisión en Vivo',
  'clientInfo.unloggedUser': 'Usuarios no Autenticados (Visitantes)',
  'clientInfo.noDepositUser': 'Usuarios sin Depósito',
  'clientInfo.noDepositUserTip': 'Usuarios sin Depósito apunta a jugadores autenticados sin primer depósito; no se puede combinar con Niveles VIP o Usuarios no Autenticados',
  'clientInfo.vipLevelGroup': 'Niveles VIP',
  'clientInfo.client': 'Cliente',
  'clientInfo.langName': 'Idioma',
  'clientInfo.forwardCode': 'Código de Reenvío',
  'clientInfo.indexSpopupType': 'Tipo de popup de página de inicio',
  'clientInfo.currency': 'Moneda',
  'clientInfo.selectCurrency': 'Seleccione moneda',
  'clientInfo.imageType': 'Posición de Visualización',
  'clientInfo.selectImageType': 'Seleccione posición de visualización',
  'clientInfo.selectDisplayTarget': 'Seleccione destino de visualización',
  'clientInfo.liveUrl': 'URL de Transmisión en Vivo',
  'clientInfo.enterLiveUrl': 'Ingrese URL de transmisión en vivo',
  'clientInfo.liveUrlMaxLength': 'La URL de transmisión en vivo no puede exceder 500 caracteres',
  'clientInfo.liveColumn': 'En Vivo',
  'clientInfo.selectLiveFilter': 'Seleccione',
  'clientInfo.hasLiveUrl': 'Tiene Transmisión en Vivo',
  'clientInfo.noLiveUrl': 'Sin Transmisión en Vivo',
  'clientInfo.indexBannerImage': 'Banner de Página Principal',
  'clientInfo.discountBannerImage': 'Banner de Descuento',
  'clientInfo.thirdPartyLoginAd': 'Anuncio de Primera Página de Inicio de Sesión de Terceros',
  'clientInfo.kioskBannerImage': 'Banner de Kiosco',
  'clientInfo.checkinActivityBannerImage': 'Banner de Actividad de Verificación e Inicio',
  'clientInfo.treasureBoxActivityBannerImage': 'Banner de Actividad de Caja de Tesoro',
  'clientInfo.loginBannerImage': 'Banner de Página de Inicio de Sesión',
  'clientInfo.registerBannerImage': 'Banner de Página de Registro',
  'clientInfo.startupBannerImage': 'Banner de Página de Inicio',
  'clientInfo.language': 'Idioma',
  'clientInfo.selectLanguage': 'Seleccione idioma',
  'clientInfo.enterMenuOrder': 'Ingrese orden del menú',
  'clientInfo.enterMenuLink': 'Ingrese enlace del menú',
  'clientInfo.redirectLink': 'Enlace/Código de Redirección',
  'clientInfo.enterRedirectLink': 'Ingrese enlace/código de redirección',
  'clientInfo.uploadImage': 'Cargue imagen',
  'clientInfo.pc': 'PC',
  'clientInfo.h5': 'H5',
  'clientInfo.app': 'APP',
  'clientInfo.kiosk': 'Kiosco',
  'clientInfo.topImage': 'Imagen Superior',
  'clientInfo.discountEntranceImage': 'Imagen de Entrada de Descuento',
  'clientInfo.logoImage': 'Imagen de Logo',
  'clientInfo.pendantImage': 'Imagen Colgante',
  'clientInfo.imageName': 'Nombre de Imagen',
  'clientInfo.enterImageName': 'Ingrese nombre de imagen',
  'clientInfo.popupType': 'Tipo de Popup de Página Principal',
  'clientInfo.selectPopupType': 'Seleccione tipo de popup',
  'clientInfo.loginBefore': 'Antes de Inicio de Sesión',
  'clientInfo.loginAfter': 'Después de Inicio de Sesión',
  'clientInfo.registerSuccess': 'Registro Exitoso',
  'clientInfo.firstDepositDetainment': 'Retención de Primer Depósito',
  'clientInfo.addSuccess': 'Añadida Exitosamente',
  'clientInfo.addFailed': 'Error al Añadir',
  'clientInfo.editSuccess': 'Editada Exitosamente',
  'clientInfo.editFailed': 'Error al Editar',
  'clientInfo.missingRedirectLink': 'Enlace/código de redirección no ingresado',
  'clientInfo.pcImageUpload': 'Carga de Imagen de PC',
  'clientInfo.h5ImageUpload': 'Carga de Imagen de H5',
  'clientInfo.appImageUpload': 'Carga de Imagen de APP',
  'clientInfo.kioskImageUpload': 'Carga de Imagen de Kiosco',
  'clientInfo.formValidationFailed': 'Error en validación del formulario',
  'clientInfo.pcImage': 'Imagen de PC',
  'clientInfo.h5Image': 'Imagen de H5',
  'clientInfo.appImage': 'Imagen de APP',
  'clientInfo.kioskImage': 'Imagen de Kiosco',
  'clientInfo.noImage': 'Sin Imagen',
  'clientInfo.dataLoadFailed': 'Error al cargar datos',
  'clientInfo.activityHomeImage': 'Página Principal de Actividad',
  'clientInfo.contactMethod': 'Método de Contacto',
  'clientInfo.enterContactMethod': 'Ingrese método de contacto',
  'clientInfo.enterSort': 'Ingrese orden de clasificación',
  'clientInfo.redirectLinkCode': 'Enlace/Código de Redirección',
  'clientInfo.enterRedirectLinkCode': 'Ingrese enlace/código de redirección',
  'clientInfo.iconUpload': 'Carga de Icono',
  'clientInfo.refreshMenuCache': 'Actualizar Caché del Menú',
  'clientInfo.menuName': 'Nombre del Menú',
  'clientInfo.enterMenuName': 'Ingrese nombre del menú',
  'clientInfo.menuIcon': 'Icono del Menú',
  'clientInfo.navName': 'Nombre de Navegación',
  'clientInfo.enterNavName': 'Ingrese nombre de navegación',
  'indexLtMenu.menuIcon': 'Icono del Menú',
  'indexBotMenu.menuName': 'Nombre del Menú',
  'indexBotMenu.enterMenuName': 'Ingrese nombre de navegación',
  'indexBotMenu.menuIcon': 'Icono del Menú',
  'indexBotMenu.menuOrder': 'Orden del Menú',
  'indexBotMenu.menuLink': 'Enlace del Menú',
  'indexBotMenu.h5Icon': 'Icono de H5',
  'indexBotMenu.pcIcon': 'Icono de PC',
  'indexBotMenu.isEnable': 'Habilitar',
  'indexBotMenu.isMain': 'Es Menú Principal',
  'clientInfo.imageTitle': 'Título de Imagen',
  'clientInfo.enterImageTitle': 'Ingrese título de imagen',
  'clientInfo.status': 'Estado',
  'clientInfo.selectStatus': 'Seleccione estado'
}
